export default "__VITE_ASSET__e04169d5__"